import { ReactNode } from 'react';

export enum HeaderVariant {
  Standard = 'standard',
  Bespoke = 'bespoke',
}

export interface StandardHeaderProps {
  title: string;
  ingress?: string;
  imageOrVideo?: ReactNode;
}

export interface BespokeHeaderProps extends StandardHeaderProps {
  runningHead?: string;
}
